import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { DashboardQueryParams } from '../types/dashboard.types';
import { useMonthlySales } from '../hooks/useMonthlySales';
import MonthlySalesChart from '../components/MonthlySalesChart';

interface MonthlySalesChartContainerProps {
  params?: DashboardQueryParams;
}

/**
 * Container component for Monthly Sales Chart
 * Handles data fetching with role-based params
 */
const MonthlySalesChartContainer: React.FC<MonthlySalesChartContainerProps> = ({
  params,
}) => {
  // Fetch monthly sales data
  const { data, loading, error } = useMonthlySales(params);

  return <MonthlySalesChart data={data} loading={loading} error={error} />;
};

export default MonthlySalesChartContainer;
